<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs> 
    <!-- <v-breadcrumbs  class="ml-2 mt-0 pt-0">{{ this.$store.state.title }} </v-breadcrumbs>  -->
    <v-card class="mx-auto ml-2 mr-2 mb-4" max-width="100%" outlined> 
      <v-dialog v-model="dialogview" max-width="80%">
        <v-card>
          <v-card-title>
            <span class="text-h6">{{ this.$store.state.title }} {{ title_dialog }}</span> 
            <span class="name_action">{{ name_action_dialog }}</span>
          </v-card-title>
          <v-card-text class="overflow-card">
            <v-form class="ml-2" id="form_privilage" lazy-validation>
              <v-container>
                  <v-data-table 
                    :items="datatopic"  
                    :items-per-page="100"
                    :hide-default-footer="true"
                    :disable-sort="true"
                    :loading="tableLoading"
                    loading-text="Loading data..."
                    flat
                    class="full-width-table"
                    >
                    <template v-slot:header >
                      <thead >
                        <tr>
                          <th > <b>TOPIC</b></th>
                          <th> <b>WINDOW SIZE</b></th>
                          <!-- <th> <b>MODE</b></th> -->
                          <th> <b>LOWER BOUND</b> </th>
                        </tr>
                      </thead>
                    </template>

                    <template v-slot:item="{ item }">
                      <tr >
                        <td ><b>{{ item.TOPIC }}</b></td>
                        <td>
                          <!-- v-show=false -->
                          <v-text-field v-show=false v-model="item.topic_name" ></v-text-field>
                          <v-text-field v-show=false v-model="item.id_topic" ></v-text-field>
                          <v-text-field class="pt-3 mr-2" v-model="item.window" label="Window Size"></v-text-field>
                        </td>
                        <td>
                            <v-text-field class="pt-3 mr-2" v-model="item.lower_bound" label="Lower Bound"></v-text-field>
                        </td>
                      </tr>
                    </template>

                </v-data-table>
              </v-container>
            </v-form>



          </v-card-text>
          <v-divider></v-divider>
          
          <v-card-actions class="py-3">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
              Cancel
            </v-btn>
            <!-- :loading="btnload" -->
            <v-btn color="blue darken-1" style="width: 120px;" :loading="btnload"  rounded dark dense  @click="postsna">
              Send Data 
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogTagcloude" max-width="80%">
        <v-card>
          <v-card-title>
            <span class="text-h6">{{ this.$store.state.title }} {{ title_dialog }}</span> 
            <span class="name_action">{{ name_action_dialog }}</span>
          </v-card-title>
          <v-card-text class="overflow-card">
            <v-form class="ml-2" id="form_privilage" lazy-validation>
              <v-container>
                  <v-data-table 
                    :items="datatopictagcloude"  
                    :items-per-page="100"
                    :hide-default-footer="true"
                    :disable-sort="true"
                    :loading="tableLoading"
                    loading-text="Loading data..."
                    flat
                    class="full-width-table"
                    >
                    <template v-slot:header >
                      <thead >
                        <tr>
                          <th > <b>TOPIC</b></th>
                          <th> <b>Keyword MIN</b></th>
                          <th> <b>Keyword MAX</b></th>
                          <th v-if="levelHonecVal" > <b>Level Cluster</b></th>
                          <th v-if="keyword_method_val" > <b>Keyword Selection Method</b> </th>
                        </tr>
                      </thead>
                    </template>

                    <template v-slot:item="{ item }">
                      <tr >
                        <td ><b>{{ item.TOPIC }}</b></td>
                        <td>
                          <!-- v-show=false -->
                          <v-text-field v-show=false v-model="item.topic_name" ></v-text-field>
                          <v-text-field v-show=false v-model="item.id_topic" ></v-text-field>
                          <v-text-field class="pt-3 mr-2" v-model="item.keywordMin" type="number" label="Keyword Min"></v-text-field>

                        </td>
                        <td>
                            <v-text-field class="pt-3 mr-2" v-model="item.keywordMax" type="number" label="Keyword Max"></v-text-field>
                        </td>

                        <td v-if="levelHonecVal">
                            <v-text-field class="pt-3 mr-2" v-model="item.levelCluster" type="number" label="Level Cluster"></v-text-field>
                        </td>
                        <td v-if="keyword_method_val" >
                            <!-- v-select for selecting the method -->
                            <v-select
                                v-model="item.keywordMethod"
                                :items="['tfidf', 'counter']"
                                label="Keyword Method"
                                class="pt-3 mr-2"
                            ></v-select>
                        </td>
                      </tr>
                    </template>

                </v-data-table>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="py-3">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closeTag">
              Cancel
            </v-btn>
            <!-- :loading="btnload" -->
            <v-btn color="blue darken-1" style="width: 120px;" :loading="btnload"  rounded dark dense  @click="posttag">
              Send Data 
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card-title class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
        <v-icon class="mr-2">mdi-link-variant</v-icon> {{ this.$store.state.title }}
      </v-card-title>
      <v-list-item-content>
        <v-card-text>
          <!--TOPIC DAN PEROIDE BERITA-->
          <v-layout
            class="d-flex ma-0 pa-0 ml-1"
            row
            wrap
          >
            <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
              <v-select
                :items="topicsentiment"
                item-text="TOPIC"
                item-value="SEQ_ID"
                v-model="selectedTopic"
                class="elevation-0 shadow-0"
                label="Topic"
                dense
                outlined
                rounded
              ></v-select>
            </v-col>
            <v-col class="d-flex ma-0 pa-0 ml-4" cols="12" sm="2">
              <v-select
                :items="periodeberita"
                v-model="selectedPeriode"
                class="elevation-0 shadow-0"
                label="Periode"
                dense
                outlined
                rounded
              >
              </v-select>
            </v-col>
            <v-col class="d-flex ma-0 pa-0 ml-4" cols="12" sm="2">
              <v-select
                :items="endpointvalue"
                v-model="selectedendpoint"
                class="elevation-0 shadow-0"
                label="Endpoint"
                dense
                outlined
                rounded
                @change="selectendpoint"
              >
              </v-select>
            </v-col>
            <v-col v-if="collection_val" class="d-flex ma-0 pa-0 ml-4" cols="12" sm="2">
              <v-select
                :items="collection"
                v-model="selectedcolection"
                class="elevation-0 shadow-0"
                label="Source"
                dense
                outlined
                rounded
              >
              </v-select>
            </v-col>
            <v-col
            class="d-flex ma-0 pa-0 ml-4"
              cols="12"
              sm="1"
            >
              <v-btn
                color="#439EDF"
                height="40"
                style="max-width: 100%;"
                dense
                dark
                rounded
                block
                @click="viewtopicsend()"
              >
                <v-icon>mdi-eye</v-icon> View
              </v-btn>
            </v-col>
          </v-layout>
        </v-card-text>
      </v-list-item-content>
    </v-card>
    <v-card class="mx-auto ml-2 mr-2 mb-4" max-width="100%" outlined>
      <v-card-title class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
        <v-icon class="mr-2">mdi-air-filter</v-icon> List {{ this.$store.state.title }}
      </v-card-title>
      <v-row class="fill-height" no-gutters>
        <v-flex class="table-user ml-auto rounded-lg" lg3>
          <v-text-field class="pt-3 mr-2" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
        </v-flex>
      </v-row>
      <v-data-table
      :headers="headers"
      :items="datatablesna"
      :search="search"
      sort-by="userdisplayname"
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      >
      <template v-slot:item.JSON_SEND="{ item }">
        <div>
          <span v-if="item.JSON_SEND.length > 100">
            {{ item.JSON_SEND.substring(0, 50) }}...
            <v-btn  :style="{ fontSize: '12px', fontStyle: 'italic', textTransform: 'none' }" text @click="openDialog(item.JSON_SEND,item.RESPONSE_DATA)">Read More</v-btn>
          </span>
          <span v-else>
            {{ item.JSON_SEND }}
          </span>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog_detail" max-width="80%">
      <v-card>
        <v-card-text style="height: 500px; overflow-y: auto;">
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <h3 class="text-subtitle-1 font-weight-medium mb-2">Request Data</h3>
                <div style="overflow-x: auto; white-space: pre; max-height: 400px;">
                  <pre>{{ fullJson }}</pre>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <h3 class="text-subtitle-1 font-weight-medium mb-2">Response Data</h3>
                <div style="overflow-x: auto; white-space: pre; max-height: 400px;">
                  <pre>{{ jsonRespon }}</pre>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="py-3">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="dialog_detail = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-card>
        <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import axios from "axios";
// import {jwtDecode} from "jwt-decode";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data () {
      return {
        fullJson:"",
        jsonRespon:"",
      dialog_detail: false, // Untuk mengontrol dialog
      headers: [
        { text: 'Topic', value: 'GROUP_NAME' },
        { text: 'Periode', value: 'PERIOD' },
        { text: 'Endpoint', value: 'ENDPOINT' },
        { text: 'Information', value: 'JSON_SEND' },
        { text: 'Time Send', value: 'CREATED_AT' },
        { text: 'Status', value: 'STATUS' },
        // { text: 'Actions', value: 'actions', sortable: false },
      ],
      datatablesna: [],
        datatopic: [], 
        datatopictagcloude: [], 
        collection_val:false,
        keyword_method_val:false,
        levelHonecVal:false,
        selectedcolection:"Twitter",
        collection: [
          "Twitter",
          "News",
          "Instagram",
          "Youtube",
          "Tik Tok",
        ],
        tableLoading: false, 
        isCommaError: [], // Status error koma
        topicsentiment: [],
        btnload:false,
        name_action_dialog: '',
        title_dialog: '',
        alert_err_attention: "",
        alertFailed: "",
        alertSuccess: "",
        search: "",
        selectedTopic: "",
        dialogview : false,
        dialogTagcloude : false,
        selectedPeriode: "All",
        periodeberita: ['All','Today', 'From Yesterday', 'This Week', 'Previous Week', 'This Month', 'Previous Month'],
        selectedEndpoint: "TAG CLOUDE",
        endpointvalue: [
         "SNA",
         "TAG CLOUDE",
          "HONEYCON"
        ],
        chip1: true,
        chip2: true,
        chip3: true,
        chip4: true,
      }
    },
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
    },
    mounted(){
      this.loadTopic();
      this.initialize();
      this.selectendpoint();
      

    },
    methods:{   
    openDialog(jsonData,jsonRespon) {
      this.fullJson = JSON.stringify(JSON.parse(jsonData), null, 2) ;
      this.jsonRespon = JSON.stringify(JSON.parse(jsonRespon), null, 2) ;
      this.dialog_detail = true;
    },
    
      async selectendpoint() {
        if(this.selectedendpoint == "SNA"){
          this.collection_val = true
        }else if(this.selectedendpoint == "HONEYCON"){
          this.collection_val = false
          this.keyword_method_val = false
          this.levelHonecVal = true
          
        }else {
          this.collection_val = false
          this.keyword_method_val = true
          this.levelHonecVal = false
        }
      },
      initialize () {
        this.tableLoading = true;
        axios.get("data-send-sna",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            var res = decryptionData(response.data.data);
            this.datatablesna = res.result
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      async loadTopic() {
        axios.get("keyword_select",
          { headers: { 'auth-token': localStorage.getItem('token_app') } },
          { dataType: 'json' }
        )
        .then((response) => {
          const data_dec = decryptionData(response.data.token);
          this.posts = data_dec.keyword;
          const data = data_dec.keyword;
          this.topicsentiment.unshift({
              SEQ_ID: "",
              TOPIC: "All"
          });
          this.selectedTopic = "";
          for (let i = 0; i < data.length; i++) {
            this.topicsentiment.push(data[i]);
          }
          
        })
        .catch((e) => {
          if (e.response) {
            const { status } = e.response;

            switch (status) {
              case 404:
                this.$refs.alert.error_login(404);
                break;
              case 403:
                this.$refs.alert.error_login(403);
                break;
              default:
                console.log("some other error"); // end up here all the time
                break;
            }
          } else {
            this.alert = true;
            setTimeout(() => {
              this.alert = false;
            }, 10000);
            this.message = "API Keyword Select refused to connect";
            this.colorAlert = "red";
          }
        });
    },
      viewtopicsend(){
        if(this.selectedendpoint == undefined){
          this.alertFailed = true;
          this.alert_err_attention =  "Endpoint Not Selected";
        }else{
          
            let filteredData = []
            if(this.selectedTopic == ""){
              filteredData = this.topicsentiment.filter(item => item.TOPIC !== "All")
                              .map(item => ({
                                SEQ_ID: item.SEQ_ID,
                                id_topic: item.SEQ_ID,
                                TOPIC: item.TOPIC,
                                topic_name: item.TOPIC
                              }));

            }else{
              filteredData = this.topicsentiment.filter(item => item.SEQ_ID == this.selectedTopic)
                              .map(item => ({
                                SEQ_ID: item.SEQ_ID,
                                id_topic: item.SEQ_ID,
                                TOPIC: item.TOPIC,
                                topic_name: item.TOPIC
                              }));
            }
            if (this.selectedTopic) {
              const selectedItem = this.topicsentiment.find(item => item.SEQ_ID == this.selectedTopic);
              if (selectedItem) {
                this.name_action_dialog = 'Topic : '+selectedItem.TOPIC+' And Periode : '+this.selectedPeriode;
              }
            } else {
              this.name_action_dialog = 'Topic : All And Periode : '+this.selectedPeriode;
            }
            this.title_dialog = this.selectedendpoint
            if(this.selectedendpoint == "SNA"){
                this.datatopic =[]
                this.datatopic = filteredData
                this.dialogview = true
            }else{
              
              this.datatopictagcloude =[]
                this.datatopictagcloude = filteredData
                this.dialogTagcloude = true
                console.log(filteredData)

            }
        }

      },
      async postsna(){
          const dataToSend = this.datatopic.map(item => ({
            id_topic: item.id_topic,
            topic_name: item.topic_name !== undefined ? item.topic_name : null,
            mode: item.mode !== undefined ? item.mode : null,
            window: item.window !== undefined ? item.window : null,
            lower_bound: item.lower_bound !== undefined ? item.lower_bound : null,
          }));

          const payload = {
            data: dataToSend,
            period: this.selectedPeriode,
            source: this.selectedcolection
          };
          console.log(dataToSend);

                this.btnload = true
        try {
          const response = await axios.post('/send-topic-sna', payload, {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          });
          console.log(response.data);
          if(response.data.status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  response.data.messages
                this.initialize ();
                this.close();
          }else{
                this.alertFailed = true;
                this.alert_err_attention =  response.data.messages;
          }
          this.btnload = false; // Matikan tombol loading
        } catch (error) {
          console.error('Error:', error);
          this.btnload = false; // Matikan tombol loading
        }
      },
      
      async posttag(){
          const dataToSend = this.datatopictagcloude.map(item => ({
            id_topic: item.id_topic,
            topic_name: item.topic_name !== undefined ? item.topic_name : null,
            keyword_min: item.keywordMin !== undefined ? item.keywordMin : null,
            keyword_max: item.keywordMax !== undefined ? item.keywordMax : null,
            level: item.levelCluster !== undefined ? item.levelCluster : null,
            keyword_method: item.keywordMethod !== undefined ? item.keywordMethod : null,
          }));

          const payload = {
            endpoint:this.title_dialog,
            data: dataToSend,
            period: this.selectedPeriode
          };
          console.log(dataToSend);

                this.btnload = true
        try {
          const response = await axios.post('/send-tag-hanic', payload, {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          });
          console.log(response.data);
          
          var res = decryptionData(response.data.data);
          if(res.status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  res.messages
                this.initialize ();
                this.closeTag();
          }else{
                this.alertFailed = true;
                this.alert_err_attention =  res.messages;
          }
          this.btnload = false; // Matikan tombol loading
          // Handle sukses
        } catch (error) {
          console.error('Error:', error);
          this.alertFailed = true;
          this.alert_err_attention =  error;
          this.btnload = false; // Matikan tombol loading
        }
      },
      
      close () {
        
        this.isAdd = false  
        
        this.dialogview = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      
      closeTag () {
        
        this.isAdd = false  
        
        this.dialogTagcloude = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    }
  }
</script>
<style scoped>
.overflow-card {
  height: 400px;
  overflow-x: auto;
  overflow-y: auto;
  white-space: pre;
}
.equal-height {
  height: 56px; /* Menyesuaikan dengan tinggi default tombol dan select */
}
.name_action {
    font-size: 12px; /* Ukuran font lebih kecil */
    font-weight: normal; /* Tidak bold */
    font-style: italic; /* Memiringkan teks */
    margin-left: 3px; 
    margin-top:6px;
}
</style>